module.exports = __webpack_public_path__ + "img/bn26.9b6746ec.png";